{
    "name": "ram",
    "version": "5.10.0",
    "scripts": {
        "ng": "ng",
        "start": "ng serve",
        "start:dev": "ng serve --configuration=development",
        "start:prod": "ng serve --configuration=local-prod",
        "build:dev": "ng build --configuration=development",
        "build:prod": "ng build --configuration=production",
        "build:prod:sentry": "ng build  --configuration=production && npm run sentry:sourcemaps",
        "build:preprod:sentry": "ng build --configuration=preprod && npm run sentry:sourcemaps",
        "watch": "ng build --configuration=development --watch",
        "test": "jest",
        "test:with-coverage": "jest --coverage",
        "test-watch": "jest --watch",
        "lint": "ng lint",
        "lint:fix": "ng lint --fix",
        "prettify": "prettier . --write --ignore-unknown",
        "sentry:sourcemaps": "sentry-cli sourcemaps inject --org syniotec-techhub --project ram-frontend ./dist/ram && sentry-cli sourcemaps upload --org syniotec-techhub --project ram-frontend ./dist/ram",
        "cert:generate": "mkdir -p ./tls & mkcert -cert-file ./tls/localhost.ram.dev.syniotec.com-cert.pem -key-file ./tls/localhost.ram.dev.syniotec.com-key.pem -ecdsa localhost.ram.dev.syniotec.com 127.0.0.1 ::1",
        "prepare": "husky"
    },
    "private": true,
    "dependencies": {
        "@ag-grid-community/locale": "^34.1.0",
        "@angular/animations": "19.2.14",
        "@angular/cdk": "19.2.19",
        "@angular/common": "19.2.14",
        "@angular/compiler": "19.2.14",
        "@angular/core": "19.2.14",
        "@angular/forms": "19.2.14",
        "@angular/google-maps": "19.2.19",
        "@angular/material": "19.2.19",
        "@angular/platform-browser": "19.2.14",
        "@angular/platform-browser-dynamic": "19.2.14",
        "@angular/router": "19.2.14",
        "@fortawesome/fontawesome-free": "^5.14.0",
        "@mobiscroll/angular": "npm:@mobiscroll/angular-ivy@5.35.5",
        "@ngneat/svg-icon": "7.1.6",
        "@ngrx/component-store": "^19.2.1",
        "@ngrx/effects": "^19.2.1",
        "@ngrx/entity": "^19.2.1",
        "@ngrx/operators": "^19.2.1",
        "@ngrx/signals": "^19.2.1",
        "@ngrx/store": "^19.2.1",
        "@ngx-translate/core": "^17.0.0",
        "@sentry/angular": "^8.52.1",
        "@swimlane/ngx-charts": "^20.5.0",
        "@sharemactechhub/frontend-library": "19.0.144",
        "@syniotec-techhub/assets": "1.21.1",
        "@syniotec-techhub/common": "19.26.1",
        "@syniotec-techhub/core": "19.24.6",
        "@syniotec-techhub/ui": "19.42.0",
        "ag-grid-angular": "^34.1.0",
        "ag-grid-community": "^34.1.0",
        "ag-grid-enterprise": "^34.1.0",
        "date-holidays": "^3.23.18",
        "es-module-shims": "^1.10.1",
        "lodash": "^4.17.23",
        "lodash-es": "^4.17.23",
        "lottie-web": "^5.12.2",
        "moment": "^2.30.1",
        "moment-timezone": "^0.5.47",
        "ng2-pdf-viewer": "^10.3.1",
        "ngrx-store-localstorage": "^19.0.0",
        "ngx-cookie-service": "^19.1.0",
        "ngx-image-cropper": "^8.1.1",
        "ngx-infinite-scroll": "19.0.0",
        "ngx-lottie": "13.0.1",
        "ngx-mask": "19.0.6",
        "ngx-permissions": "^19.0.0",
        "rxjs": "~7.8.0",
        "socket.io-client": "^4.8.1",
        "tslib": "^2.8.1",
        "zone.js": "^0.15.0"
    },
    "devDependencies": {
        "@angular-architects/native-federation": "19.0.23",
        "@angular-devkit/architect": "0.1901.9",
        "@angular-devkit/build-angular": "19.2.15",
        "@angular/build": "19.2.15",
        "@angular/cli": "19.2.15",
        "@angular/compiler-cli": "19.2.14",
        "@commitlint/cli": "^20.1.0",
        "@commitlint/config-conventional": "^20.0.0",
        "@googlemaps/jest-mocks": "^2.21.4",
        "@happy-dom/jest-environment": "^17.0.0",
        "@ngneat/spectator": "^19.5.0",
        "@ngrx/eslint-plugin": "^19.2.1",
        "@sentry/cli": "^2.41.1",
        "@smarttools/eslint-plugin-rxjs": "^1.0.18",
        "@types/eslint-config-prettier": "^6.11.3",
        "@types/google.maps": "^3.58.1",
        "@types/jest": "^29.5.14",
        "@types/lodash": "^4.17.15",
        "@types/lodash-es": "^4.17.12",
        "@types/node": "22.13.1",
        "@typescript-eslint/eslint-plugin": "^8.23.0",
        "@typescript-eslint/parser": "^8.23.0",
        "angular-eslint": "19.0.2",
        "eslint": "^9.16.0",
        "eslint-config-prettier": "^10.0.1",
        "eslint-plugin-prettier": "^5.2.3",
        "eslint-plugin-unused-imports": "^4.1.4",
        "husky": "^9.1.7",
        "jest": "^29.7.0",
        "jest-canvas-mock": "^2.5.2",
        "jest-junit": "^16.0.0",
        "jest-preset-angular": "^14.5.1",
        "lint-staged": "^15.4.3",
        "path": "^0.12.7",
        "prettier": "3.7.4",
        "pretty-quick": "^4.2.2",
        "ts-node": "^10.9.2",
        "typescript": "~5.7.3",
        "typescript-eslint": "8.18.0"
    },
    "lint-staged": {
        "**/*": "prettier --write --ignore-unknown",
        "*.{ts,tsx}": [
            "eslint"
        ]
    }
}
